import { useEffect, useState } from "react";
import {
  EmailTemplateVarsApi,
  type EmailTemplateVocabulary,
} from "../api/emailTemplateVars";

/**
 * Fetch the variable catalog once.
 *
 * On failure `vocab` stays null and every consumer goes inert -- no
 * highlighting, no fake-data fill. We deliberately ship no bundled fallback: a
 * stale copy can claim a variable exists that doesn't (rendering blank in a
 * real email), which is worse than showing no colour at all.
 */
export function useEmailTemplateVars(): {
  vocab: EmailTemplateVocabulary | null;
  loading: boolean;
} {
  const [vocab, setVocab] = useState<EmailTemplateVocabulary | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    EmailTemplateVarsApi.get()
      .then((v) => {
        if (!cancelled) setVocab(v);
      })
      .catch(() => {
        if (!cancelled) setVocab(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { vocab, loading };
}
